export default __webpack_public_path__ + "static/media/screen8.7f69ac21.png";